// Pure HTTP communication - no business logic
import {AxiosResponse} from "axios";

import CoreApi from "@/src/modules/core/api";
import axios from "@/src/modules/core/lib/axios";

import type {AppLocale} from "../i18n";
import {Me} from "../types";

class MeApi extends CoreApi {
  async get(): Promise<AxiosResponse<Me>> {
    return super.get("me");
  }

  async patchLocale(locale: AppLocale | null): Promise<AxiosResponse<Me>> {
    return axios({
      url: "me",
      method: "patch",
      data: {locale},
    });
  }
}

export const meApi = new MeApi();
